import { FeatureService } from '../services/FeatureService';
export function useFeatureService(): FeatureService {
  return new FeatureService(useApiClient(), useUserStore());
}
